import { AlertService } from './../../services/alert.service';
import { Component, OnInit } from '@angular/core';
import { MenuController, LoadingController } from '@ionic/angular';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.page.html',
  styleUrls: ['./support.page.scss'],
})
export class SupportPage implements OnInit {
  supportForm: FormGroup;
  showWarning = false;
  year = new Date().getFullYear();
  constructor(
    private menuCtrl: MenuController,
    private formBuilder: FormBuilder,
    private messageService: SupportService,
    private alertService: AlertService,
    private loadingCtrl: LoadingController
  ) {}

  ngOnInit() {
    this.supportForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      message: new FormControl('', Validators.required),
    });
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  submitForm() {
    if (this.supportForm.valid) {
      this.showWarning = false;
      this.loadingCtrl.create({ keyboardClose: true }).then((loadingEl) => {
        loadingEl.present();
        let data = {
          name: this.supportForm.value.name,
          email: this.supportForm.value.email,
          message: this.supportForm.value.message,
          date: new Date(),
        };

        this.messageService.addNewMessage(data).subscribe(
          (res) => {
            this.supportForm.reset();
            loadingEl.dismiss();
            this.alertService.showAlert(
              'Success',
              'Support form successfully submitted',
              ['Okay']
            );
          },
          (err) => {
            loadingEl.dismiss();
            this.alertService.showFirebaseAlert(err);
          }
        );
      });
    } else {
      this.showWarning = true;
    }
  }
  goToLink() {
    window.open('https://www.linkedin.com/in/rasheek/', '_blank');
  }
}
